import { fireTag } from '@vue-util/tagManager';

export const getAvailabilityTypes = (bagItem) => {
  let isAvblForShip;
  let isAvblForBOSS;
  let isAvblForBOPS;

  if (bagItem) {
    isAvblForShip = bagItem.flags?.shippingAvailability;
    isAvblForBOSS = bagItem.flags?.shipToStoreAvailability;
    isAvblForBOPS = bagItem.flags?.storeAvailability;

    if (isAvblForBOSS && !isAvblForShip) {
      return 'ship-n:bops-n:boss-y';
    } if (isAvblForBOPS && !isAvblForShip) {
      return 'ship-n:bops-y:boss-n';
    } if (isAvblForShip && (!isAvblForBOPS && !isAvblForBOSS)) {
      return 'ship-y:bops-n:boss-n';
    } if (isAvblForShip && isAvblForBOPS) {
      return 'ship-y:bops-y:boss-n';
    } if (isAvblForShip && isAvblForBOSS) {
      return 'ship-y:bops-n:boss-y';
    }
  }

  return '';
};

export const getAvailabilitySelect = (bagItem) => {
  if (bagItem) {
    if (bagItem.flags?.pickUpFromStore) {
      return 'bops';
    } if (bagItem.flags?.shipToStoreSelected) {
      return 'boss';
    } if (bagItem.product?.availability?.message && bagItem.product?.availability?.message) {
      return 'ship';
    }
  }
  return '';
};

export const fireErrorLinkTagging = (productIds, items, anchorProduct) => {
  let productType = 'anchor product';
  if (productIds.length > 1) {
    if (items && items.length > 0 && items[0].bag.sections.bagItems.items) {
      const [bagItem] = items[0].bag.sections.bagItems.items;
      productType = (bagItem.product.id === anchorProduct) ? 'recommended product' : 'anchor product';
    }
  } else {
    productType = (productIds[0] === anchorProduct.toString()) ? 'anchor product' : 'recommended product';
  }
  fireTag('link', {
    // eslint-disable-next-line no-useless-escape
    error_message: [`We\'re sorry ${productType} is unavailable`],
  });
};

export const fireATBLinkTag = (bagItems, anchorProductId) => {
  const uTagData = {
    event_name: 'add to bag',
    is_big_ticket: [],
    product_availability: [],
    product_availability_select: [],
    product_id: [],
    product_name: [],
    product_upc: [],
    product_color: [],
    product_size: [],
    product_quantity: [],
    product_price: [],
    product_original_price: [],
    product_pricing_state: [],
    product_sub_total: [],
    product_type: [],
    t_category_id: [],
    product_protection_plan: [],
    bag_add_location: 'frequently bought together',
    product_is_anchor: [],
  };
  bagItems.forEach((item) => {
    const [bagItem] = item.bag.sections.bagItems.items;
    const data = item.bag.meta.analytics && item.bag.meta.analytics.data;
    uTagData.is_big_ticket.push(String(data.is_big_ticket));
    uTagData.product_availability.push(String(getAvailabilityTypes(bagItem)));
    uTagData.product_availability_select.push(String(getAvailabilitySelect(bagItem)));
    uTagData.product_id.push(String(data.product_id));
    uTagData.product_name.push(String(data.product_name));
    uTagData.product_upc.push(String(data.product_upc));
    uTagData.product_color.push(String(data.product_color ? data.product_color : ''));
    uTagData.product_size.push(String(data.product_size ? data.product_size : ''));
    uTagData.product_quantity.push(String(data.product_quantity));
    uTagData.product_price.push(String(data.product_price));
    uTagData.product_original_price.push(String(data.product_original_price));
    uTagData.product_pricing_state.push(bagItem.colorwayPrice?.priceTypeText?.length ? bagItem.colorwayPrice.priceTypeText.toString() : '');
    uTagData.product_sub_total.push(String(data.product_sub_total));
    uTagData.product_type.push('member');
    uTagData.t_category_id.push(String(data.product_category_id));
    uTagData.product_protection_plan.push('');
    uTagData.product_is_anchor.push(data.product_id[0] === String(anchorProductId));
  });

  fireTag('link', uTagData, { immediate: true });
};
